import React, { useContext } from 'react';
import { MobileFilterDialog } from './MobileFilterView';
import { MobileSortView } from './MobileSortView';
import { Group } from './types';
import { sortOptions } from './util';
import { WalletSortAndFilterContext } from './context';

interface MobileSortAndFilterViewProps {
    groups: Group[];
}

export const MobileSortAndFilterView = ({ groups }: MobileSortAndFilterViewProps) => {
    const { sortedBy, setSortedBy } = useContext(WalletSortAndFilterContext);
    const options = Object.values(sortOptions);

    return (
        <div className="flex justify-evenly">
            <MobileFilterDialog groups={groups} />
            <MobileSortView options={options} sortedByField={sortedBy} onChange={setSortedBy} />
        </div>
    );
};
